<template>
<div class="chapter">
<div class="inner_page">
<h2 class="pt"><a id="page_1"></a><span class="bold">THE EARLY YEARS</span></h2>
<div class="top">
<p class="ch-blk">We all have dreams. But in order to make dreams come into reality, it takes an awful lot of determination, dedication, self-discipline, and effort.</p>
<p class="blkr">Jesse Owens</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Part01.vue?32f2552e